module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/daodi-logo-141ea95a06efd7cac275f9101b04b990.svg&quot;;"